module.exports = __webpack_public_path__ + "img/VisualRecognition.1a506e7f.svg";